module.exports = __webpack_public_path__ + "img/app_qrcode.1d89116f.png";